import useTestId from '@ori/testid-generator';
import { BANNER_CATALOGUE_DATE_RANGE, BANNER_CATALOGUE_TITLE, BANNER_CUSTOM_CONTENT, BANNER_QUIZ_TEXT, BANNER_QUIZ_TITLE } from '../../common';
import { CatalogueDateRange, CatalogueTitle, QuizText, QuizTitle } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Content = props => {
  const {
    type
  } = props;
  const {
    getTestId
  } = useTestId();
  switch (type) {
    case 'catalogue':
      {
        const {
          dateRange,
          title
        } = props;
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(CatalogueDateRange, {
            "data-testid": getTestId(BANNER_CATALOGUE_DATE_RANGE),
            children: dateRange
          }), /*#__PURE__*/_jsx(CatalogueTitle, {
            variant: "h6",
            "data-testid": getTestId(BANNER_CATALOGUE_TITLE),
            children: title
          })]
        });
      }
    case 'custom':
      {
        const {
          customContent
        } = props;
        return /*#__PURE__*/_jsx("div", {
          "data-testid": getTestId(BANNER_CUSTOM_CONTENT),
          children: customContent
        });
      }
    case 'quiz':
      {
        const {
          text,
          title,
          maxLines
        } = props;
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(QuizTitle, {
            maxLines: maxLines,
            "data-testid": getTestId(BANNER_QUIZ_TITLE),
            children: title
          }), /*#__PURE__*/_jsx(QuizText, {
            "data-testid": getTestId(BANNER_QUIZ_TEXT),
            maxLines: maxLines,
            children: text
          })]
        });
      }
    default:
      return null;
  }
};
//# sourceMappingURL=Content.js.map